import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { HcPatientMedicalTestConsultationLinkContainerModel } from '../../../../../models/aggregates/healthcare/medical_test_consultation_link_container.model'

@Injectable({ providedIn: 'root' })
export class HcPatientMedicalTestConsultationLinkBackofficeEpService extends BaseApiTemplateService<HcPatientMedicalTestConsultationLinkContainerModel> {
    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-medical-test-consultation-links";

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-medical-test-consultation-links' + '/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + 'patient-medical-test-consultation-links' + '/backoffice-ep';
        this.httpClient = http;
    }
}